import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import AssistirMaisTardeMain from '../components/assistir-mais-tarde';

const MinhasRedacoes = () => {
  return (
    <Wrapper>
      <SEO pageTitle={'Minhas Redaçoes'} />
      <AssistirMaisTardeMain />
    </Wrapper>
  );
};

export default MinhasRedacoes;